var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loggedIn && !_vm.isHelpPage)?_c('div',{class:[
      'page secondary--text box',
       {'box_overflow_page': _vm.isOpenDialog} ],style:([
      {top: _vm.topCssProp.valuePx},
      {'min-width': 'auto'} ])},[_c('app-bar',{attrs:{"is-mobile":_vm.isMobile}}),(!_vm.isMobile)?_c('sidebar'):_vm._e(),_c('router-view')],1):_c('router-view'),(_vm.stackCaptha)?_c('stack-captcha'):_vm._e(),(!_vm.cookiesConfirmed)?_c('cookies'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }